module.exports = __webpack_public_path__ + "static/img/workDynamics.46c5d44.png";


//////////////////
// WEBPACK FOOTER
// ./static/webp1/workDynamics.png
// module id = jsWG
// module chunks = 1